import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { CartActions } from '@spartacus/cart/base/core';
import { GlobalMessageActions, GlobalMessageType, LoggerService, SiteContextActions, TranslationService, tryNormalizeHttpError } from '@spartacus/core';
import { from, Observable } from 'rxjs';
import { catchError, map, mergeMap, switchMap } from 'rxjs/operators';
import { CustomValidateCartService } from '../../../../../services/cart/validate-cart.service';
import { CustomUnavailableProductsConnector } from '../../connectors';
import {
  CustomUnavailableProductsActionTypes,
  LoadUnavailableProducts,
  LoadUnavailableProductsFail,
  LoadUnavailableProductsSuccess
} from '../actions/custom-unavailable-products.action';

@Injectable()
export class CustomUnavailableProductsEffect {
  protected logger = inject(LoggerService);
  private contextChange$;

  constructor(
    private actions$: Actions,
    private unavailableProductsConnector: CustomUnavailableProductsConnector,
    protected translation: TranslationService,
    protected customValidateCartService: CustomValidateCartService
  ) {
    this.contextChange$ = this.actions$.pipe(ofType(SiteContextActions.CURRENCY_CHANGE, SiteContextActions.LANGUAGE_CHANGE));
  }

  LoadUnavailableProducts$: Observable<LoadUnavailableProductsFail | LoadUnavailableProductsSuccess | CartActions.LoadCart | GlobalMessageActions.AddMessage> = createEffect(() =>
    this.actions$.pipe(
      ofType(CustomUnavailableProductsActionTypes.LOAD_UNAVAILABLEPRODUCTS),
      map((action: LoadUnavailableProducts) => action.payload),
      mergeMap((payload) =>
        this.unavailableProductsConnector.unavailableProducts(payload.userId, payload.cartId).pipe(
          switchMap((data) => {
            return [new LoadUnavailableProductsSuccess(data)];
          }),
          catchError((error) =>
            from([
              new LoadUnavailableProductsFail(tryNormalizeHttpError(error, this.logger)),
              new GlobalMessageActions.AddMessage({
                text: { key: error?.error?.errors[0]?.type },
                type: GlobalMessageType.MSG_TYPE_ERROR
              })
            ])
          )
        )
      )
    )
  );
}

export const effectsUnavailableProducts: any[] = [CustomUnavailableProductsEffect];
